import { FormattedMessage } from 'react-intl';

import { supplierGridProperties } from '../../data/suppliers-properties';
import { messages } from '../messages';

type SupplierData = {
  supplierAddress?: string;
};

const name = <FormattedMessage {...messages.supplierAddressColumnHeader} />;

/**
 * Supplier Address column configuration
 * Displays the address of the supplier
 */
export const supplierAddressColumn = {
  name,
  render: (data: SupplierData) => data.supplierAddress,
  id: supplierGridProperties.supplierAddress,
};
